<footer id="footer" class="bg-neutral-50 border-t border-neutral-200 py-3 px-4 text-center text-neutral-500 text-sm relative">
  <p-button [disabled]="!showSideBarButtonVisible" (onClick)="showSideBarClicked()" icon="pi pi-angle-right" class="fixed left-4 bottom-[6px] z-50" styleClass="!w-8 !h-8"></p-button>
  <p *ngIf="posUiVersion | async as version">
    {{ 'footer.copyright' | translate:{ version } }}
  </p>
  <div *ngIf="showSyncBacklog" class="absolute left-16 bottom-3 flex items-center gap-3">
    <app-sync-backlog-indicator></app-sync-backlog-indicator>
  </div>
  <div *ngIf="connectionStatus | async as status" class="flex items-center gap-1.5 text-xs text-neutral-500 select-none absolute right-4 bottom-3">
    <span
      class="inline-block w-2 h-2 rounded-full"
      [class.bg-green-500]="status === 'online'"
      [class.bg-amber-500]="status === 'reconnecting'"
      [class.bg-red-500]="status === 'offline'"
    ></span>
    <span>{{ 'footer.status_label' | translate:{ status: ('common.' + status | translate) } }}</span>
  </div>
</footer>
